import classNames from "classnames"
import {
  add,
  differenceInDays,
  format,
  isAfter,
  isBefore,
  max,
  min,
  parse,
  sub,
} from "date-fns"
import DatePicker from "legacy/DatePicker"
import BSModal from "legacy/boater-reservation-flow/BSModal"
import PricingSummary from "legacy/boater-reservation-flow/PricingSummary"
import PromoCode from "legacy/boater-reservation-flow/PromoCode"
import BoatPicker from "legacy/boater-reservation-flow/boat/BoatPicker"
import BookNowEstimate from "legacy/boater-reservation-flow/price-estimate/BookNowEstimate"
import {
  areSame,
  centsToDollarsRaw,
  feetToInches,
  hasAny,
  isset,
  numbersOnly,
} from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

/* eslint-disable camelcase */

class PriceEstimator extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      processing: false,
      endPointFail: false,
      showModal: false,
      loadingBlackouts: false,
      promoCodeErrorMessage: null,
      boatErrors: {},
      dateErrors: false,
      loadingDockwaPlusProductInformation: false,
      showDockwaPlusModal: false,
      dockwaPlusProductInformation: null,
      csrfToken:
        document.querySelector('meta[name="csrf-token"]').content || "",
      paymentMethodCards: this.props.state.paymentMethods.filter(
        (paymentMethod) => paymentMethod.type === "PaymentMethod::Card"
      ),
    }

    // Create refs
    this.heightInputRef = React.createRef()
    this.draftInputRef = React.createRef()
    this.fetchPriceEstimate = this.fetchPriceEstimate.bind(this)
    this.bookNow = this.bookNow.bind(this)
    this.getBookNowData = this.getBookNowData.bind(this)
    this.arrivalState = this.arrivalState.bind(this)
    this.departureState = this.departureState.bind(this)
    this.validateBoatDimensions = this.validateBoatDimensions.bind(this)
    this.handleLOAChange = this.handleLOAChange.bind(this)
    this.handleDrawChange = this.handleDrawChange.bind(this)
    this.handleHeightChange = this.handleHeightChange.bind(this)
    this.canCheckoutTill = this.canCheckoutTill.bind(this)
    this.onlyCheckoutSelected = this.onlyCheckoutSelected.bind(this)
    this.setCheckinBoundary = this.setCheckinBoundary.bind(this)
    this.doesOverlapBlackout = this.doesOverlapBlackout.bind(this)
    this.isLongerThanMaxNights = this.isLongerThanMaxNights.bind(this)
    this.blackoutsKeyVal = this.blackoutsKeyVal.bind(this)
    this.handleHideModal = this.handleHideModal.bind(this)
    this.boatSelector = this.boatSelector.bind(this)
    this.dockTypeSelector = this.dockTypeSelector.bind(this)
    this.changeDockType = this.changeDockType.bind(this)
    this.datepickerChangeDockType = this.datepickerChangeDockType.bind(this)
    this.debounceRequestsAndSetStateRestrictions = _.debounce(
      this.debounceRequestsAndSetStateRestrictions.bind(this),
      1000
    )
    this.updateBlackouts = this.updateBlackouts.bind(this)
    this.startLoadingBlackouts = this.startLoadingBlackouts.bind(this)
    this.endLoadingBlackouts = this.endLoadingBlackouts.bind(this)
    this.setDates = this.setDates.bind(this)
    this.clearDates = this.clearDates.bind(this)
    this.loaSection = this.loaSection.bind(this)
    this.verticalSection = this.verticalSection.bind(this)
    this.oppositeSpaceType = this.oppositeSpaceType.bind(this)
    this.handleJsonResponse = this.handleJsonResponse.bind(this)
    this.handlePriceEstimateResponse =
      this.handlePriceEstimateResponse.bind(this)
    this.handlePriceEstimateError = this.handlePriceEstimateError.bind(this)
    this.loaInputRef = React.createRef()
    this.arrivalInputRef = React.createRef()
    this.departureInputRef = React.createRef()
    this.dockSelectorRef = React.createRef()
  }

  componentDidMount() {
    this.props.setHeader("")
    $(document).delegate("td.disabled", "click", () => {
      if (this.props.waitlistFeature) {
        const button = $(".datepicker-waitlist button")
        button.tooltip({
          trigger: "manual",
          title:
            "If a date isn't available to book, you can join the waitlist.",
          placement: "bottom",
        })
        button.tooltip("show")
        setTimeout(() => button.tooltip("hide"), 5000)
      } else {
        alert(
          "Sorry! You are unable to select a date that has been grayed out. This is usually because the marina does not have availability on this day."
        )
      }
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.state.paymentMethods !== prevProps.state.paymentMethods) {
      this.setState({
        paymentMethodCards: this.props.state.paymentMethods.filter(
          (paymentMethod) => paymentMethod.type === "PaymentMethod::Card"
        ),
      })
    }
  }

  bookNow() {
    if (this.state.promoCodeErrorMessage) {
      return (
        <p id="promoCodeErrorMessage" className="text-danger text-center">
          {this.state.promoCodeErrorMessage}
        </p>
      )
    } else if (hasAny(Object.keys(this.state.boatErrors))) {
      return (
        <p id="boatDoesNotFitErrorMessage" className="text-danger text-center">
          Your boat cannot fit at this marina, please edit the dimensions of
          your boat and try again.
        </p>
      )
    } else if (this.state.dateErrors) {
      return (
        <p id="badDatesErrorMessage" className="text-danger text-center">
          Your arrival date must precede your departure date, please edit your
          dates and try again.
        </p>
      )
    } else if (this.state.endPointFail === true) {
      return (
        <p
          id="somethingWentWrongErrorMessage"
          className="text-danger text-center"
        >
          Something went wrong, please contact mayday@dockwa.com if the issue
          continues.
        </p>
      )
    } else if (isset(this.props.state.fetchV2PriceError)) {
      return (
        <p
          id="somethingWentWrongErrorMessage"
          className="text-danger text-center"
        >
          Something went wrong, please contact mayday@dockwa.com if the issue
          continues.
        </p>
      )
    }

    if (this.props.useDockwaPlusPricing) {
      const {
        state,
        setGlobalState,
        routeTo,
        openDockwaPlusModal,
        marina,
        state: {
          pricingSummary,
          loadingDockwaPlusProductInformation,
          fetchV2PriceLoading,
        },
      } = this.props

      return (
        <PricingSummary
          lineItems={pricingSummary}
          state={state}
          handleOpenModal={openDockwaPlusModal}
          key={"price-summary"}
          loadingProductInformation={loadingDockwaPlusProductInformation}
          loadingPricing={fetchV2PriceLoading}
          setGlobalState={setGlobalState}
          routeTo={routeTo}
          marina={marina}
          embedForm={this.props.embedForm}
        />
      )
    } else if (this.state.processing === true) {
      return (
        <span
          id="priceEstimatorLoading"
          className="icon icon-spinner icon-spin price-estimate-spinner"
        />
      )
    } else {
      return (
        <BookNowEstimate
          state={this.props.state}
          routeTo={this.props.routeTo}
          dockPrice={this.props.state.initialDockPrice}
          mooringPrice={this.props.state.initialMooringPrice}
          setGlobalState={this.props.setGlobalState}
          marina={this.props.marina}
          embedForm={this.props.embedForm}
        />
      )
    }
  }

  getBookNowData() {
    if (
      this.props.state.loa > 0 &&
      isset(this.props.state.arrival) &&
      isset(this.props.state.departure) &&
      !isAfter(
        parse(this.props.state.arrival, "P", new Date()),
        parse(this.props.state.departure, "P", new Date())
      )
    ) {
      this.setState({ processing: true, dateErrors: false })
      this.props.setGlobalState({
        estimateBtnPressed: false,
        initialPriceEstimate: true,
      })
      const postObject = {
        length_overall: this.props.state.loa * 12,
        check_in_date: this.props.state.arrival,
        check_out_date: this.props.state.departure,
        requested_space_type: this.props.state.dockType,
      }
      if (
        isset(this.props.state.promoCode) &&
        !this.props.useDockwaPlusPricing
      ) {
        postObject.promo_code_id = this.props.state.promoCode.id
      }
      if (isset(this.props.state.referralCode)) {
        postObject.referral_code_id = this.props.state.referralCode.id
      }
      if (isset(this.props.state.beam)) {
        postObject.beam = this.props.state.beam * 12
      }

      if (this.props.useDockwaPlusPricing) {
        const { fetchV2PriceEstimate } = this.props.state
        fetchV2PriceEstimate()
          .then((data) => {
            const {
              marina: { mcomId: marina_id, name: marina_name },
              state: { loa, draft, arrival, departure },
            } = this.props

            const {
              pricing_summary,
              dockwa_plus_offer,
              membership,
              promo_code_id,
              discount_percentage,
              discounted_price_value,
            } = data

            const pricingSummary = pricing_summary || []
            const { amount: price_value } = pricingSummary.slice(-1).pop() || {}

            Amplitude.trackEvent("reservation_flow:price_calculated", {
              experience_name: "reservation_flow",
              marina_id,
              marina_name,
              loa: feetToInches(loa),
              draft: feetToInches(draft),
              arrival: new Date(Date.parse(arrival)),
              departure: new Date(Date.parse(departure)),
              price_value,
              promo_code_id,
              discount_percentage,
              discounted_price_value,
              membership,
              dockwa_plus_offer_promo_code_id: dockwa_plus_offer
                ? dockwa_plus_offer.promo_code_id
                : null,
              dockwa_plus_offer_discount_percentage: dockwa_plus_offer
                ? dockwa_plus_offer.discount_percentage
                : null,
              dockwa_plus_offer_discounted_price_value: dockwa_plus_offer
                ? dockwa_plus_offer.discounted_amount
                : null,
              embed_form: !!this.props.embedForm,
            })

            this.setState({ processing: false })
          })
          .catch((error) => {
            const {
              marina: { mcomId: marina_id, name: marina_name },
              state: { loa, draft, arrival, departure },
            } = this.props

            Amplitude.trackEvent("reservation_flow:price_calculation_failed", {
              experience_name: "reservation_flow",
              marina_id,
              marina_name,
              loa: feetToInches(loa),
              draft: feetToInches(draft),
              arrival: new Date(Date.parse(arrival)),
              departure: new Date(Date.parse(departure)),
              error: error.message,
              embed_form: !!this.props.embedForm,
            })
          })
      } else {
        this.fetchPriceEstimate(postObject).then(() => {
          this.setState({ processing: false })
        })
      }
    } else {
      this.props.setGlobalState({
        initialPriceEstimate: false,
        initialDockPrice: false,
        initialMooringPrice: false,
      })

      if (
        isset(this.props.state.arrival) &&
        isset(this.props.state.departure) &&
        isAfter(
          parse(this.props.state.arrival, "P", new Date()),
          parse(this.props.state.departure, "P", new Date())
        )
      ) {
        this.setState({ dateErrors: true })
      }

      this.setState({ endPointFail: false, promoCodeErrorMessage: null })
    }
  }

  handleJsonResponse(response) {
    return response
      .json()
      .catch(() => {
        return Promise.reject(new Error("Invalid JSON response"))
      })
      .then((data) => {
        if (!response.ok) {
          const errorMessage = (data && data.error) || "Unknown error"
          return Promise.reject(new Error(errorMessage))
        }
        return data
      })
  }

  handlePriceEstimateResponse(data) {
    const stateObject = {}

    const hasDockPrice = Object.hasOwn(data, "Dock")
    const hasMooringPrice = Object.hasOwn(data, "Mooring")

    if (hasDockPrice) {
      stateObject.initialDockPrice = data.Dock.total
      stateObject.initialMooringPrice = false
      stateObject.minNightRequirement = data.Dock.minimum_night_requirement
    } else if (hasMooringPrice) {
      stateObject.initialMooringPrice = data.Mooring.total
      stateObject.initialDockPrice = false
      stateObject.minNightRequirement = data.Mooring.minimum_night_requirement
    }

    this.props.setGlobalState(stateObject)
    this.setState({ endPointFail: false, promoCodeErrorMessage: null })

    Amplitude.trackEvent("reservation_flow:price_calculated", {
      experience_name: "reservation_flow",
      marina_id: this.props.marina.mcomId,
      marina_name: this.props.marina.name,
      loa: feetToInches(this.props.state.loa),
      draft: feetToInches(this.props.state.draft),
      arrival: new Date(Date.parse(this.props.state.arrival)),
      departure: new Date(Date.parse(this.props.state.departure)),
      price_value: centsToDollarsRaw(
        Object.hasOwn(data, "Mooring") ? data.Mooring.total : data.Dock.total
      ),
      embed_form: !!this.props.embedForm,
    })
  }

  handlePriceEstimateError(error) {
    const errorMessage = error.message || "Unknown error"

    if (errorMessage.toLowerCase().includes("coupon code")) {
      this.setState({
        promoCodeErrorMessage: errorMessage,
        endPointFail: true,
      })
    } else {
      this.setState({
        endPointFail: true,
        promoCodeErrorMessage: null,
      })
    }

    console.error(error)
  }

  fetchPriceEstimate(postObject) {
    return fetch(this.props.priceEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.state.csrfToken,
      },
      body: JSON.stringify(postObject),
    })
      .then(this.handleJsonResponse)
      .then(this.handlePriceEstimateResponse)
      .catch(this.handlePriceEstimateError)
  }

  arrivalState(value) {
    this.props.setGlobalState({ arrival: value }, () => {
      this.canCheckoutTill()
      this.setCheckinBoundary()
      this.getBookNowData()
    })
  }

  departureState(value) {
    this.props.setGlobalState({ departure: value }, () => {
      this.canCheckoutTill()
      this.setCheckinBoundary()
      this.getBookNowData()
    })
  }

  validateBoatDimensions() {
    this.props.setGlobalState({ nextDisabled: false })
    const { dockType, loa, beam, draft, height } = this.props.state
    const boat = {
      loa: loa * 12,
      beam: beam * 12,
      depth: draft * 12,
      height: height * 12,
    }
    $.post(
      this.props.boatDimensionValidationEndpoint,
      { requested_space_type: dockType, boat },
      (data) => {
        this.setState({ boatErrors: data.error })
      },
      "json"
    ).fail(() => {
      alert(
        "Something went wrong, please contact Dockwa support at mayday@dockwa.com"
      )
    })
  }

  handleLOAChange(event) {
    this.props.setGlobalState({ loa: numbersOnly(event.target.value) }, () => {
      this.debounceRequestsAndSetStateRestrictions("loa")
    })
  }

  handleDrawChange(event) {
    this.props.setGlobalState(
      { draft: numbersOnly(event.target.value) },
      () => {
        this.debounceRequestsAndSetStateRestrictions("draw")
      }
    )
  }

  handleHeightChange(event) {
    this.props.setGlobalState(
      { height: numbersOnly(event.target.value) },
      () => {
        this.debounceRequestsAndSetStateRestrictions("height")
      }
    )
  }

  canCheckoutTill() {
    let start
    // if the arrival date is set
    if (isset(this.props.state.arrival)) {
      let closestBlackout = parse(
        this.props.state.marinaEndDate,
        "P",
        new Date()
      )
      // min with the days in advance
      if (isset(this.props.state.daysInAdvance)) {
        closestBlackout = min([
          add(new Date(), {
            days: parseInt(this.props.state.daysInAdvance) + 1,
          }),
          closestBlackout,
        ])
      }
      // min with the max number of nights that you can stay
      if (isset(this.props.state.maxNights)) {
        closestBlackout = min([
          add(parse(this.props.state.arrival, "P", new Date()), {
            days: this.props.state.maxNights,
          }),
          closestBlackout,
        ])
      }

      const blackoutSet = this.props.state.arrivalBlackouts || []
      let blackout
      start = parse(this.props.state.arrival, "P", new Date())

      // loop through and check if the blackout is between the start and end date
      const blackoutLength = blackoutSet.length
      if (blackoutLength > 0) {
        for (let i = 0; i < blackoutLength; i++) {
          blackout = parse(blackoutSet[i], "P", new Date())
          if (isAfter(blackout, start) && isBefore(blackout, closestBlackout)) {
            closestBlackout = blackout
            break
          }
        }
      }

      // format back to string
      closestBlackout = format(closestBlackout, "P")
      // clear end date
      if (
        this.doesOverlapBlackout(closestBlackout) ||
        this.isLongerThanMaxNights()
      ) {
        this.props.setGlobalState({ departure: "" })
      }

      // if they do NOT offer day trip add one day to the departure start date
      if (this.props.state.offerDayTrip === false) {
        start = add(start, { days: 1 })
      }
      this.props.setGlobalState({
        departureStartDate: format(start, "P"),
        departureEndDate: closestBlackout,
        departureBlackouts: null,
      })
    } else {
      // if the arrival date is not set
      start = parse(this.props.state.arrivalStartDate, "P", new Date())
      // if they do NOT offer day trip, add one day to the departure start date
      if (this.props.state.offerDayTrip === false) {
        start = add(start, { days: 1 })
      }
      this.props.setGlobalState({
        departureStartDate: format(start, "P"),
        departureEndDate: this.props.state.arrivalEndDate,
        departureBlackouts: this.props.state.shiftedDepartureBlackouts,
      })
    }
  }

  onlyCheckoutSelected() {
    return !isset(this.props.state.arrival) && isset(this.props.state.departure)
  }

  setCheckinBoundary() {
    if (this.onlyCheckoutSelected()) {
      let closestBlackout = parse(
        this.props.state.marinaStartDate,
        "P",
        new Date()
      )
      if (isset(this.props.state.maxNights)) {
        closestBlackout = max([
          sub(parse(this.props.state.departure, "P", new Date()), {
            days: this.props.state.maxNights,
          }),
          closestBlackout,
        ])
      }

      const blackoutSet = this.props.state.arrivalBlackouts || []
      let blackout
      let latestArrivalEnd = parse(this.props.state.departure, "P", new Date())

      const blackoutLength = blackoutSet.length
      if (blackoutLength > 0) {
        // this logic is basically the reversed case for canCheckoutTill
        for (let i = blackoutLength - 1; i >= 0; i--) {
          blackout = parse(blackoutSet[i], "P", new Date())
          if (
            isAfter(blackout, closestBlackout) &&
            isBefore(blackout, latestArrivalEnd)
          ) {
            closestBlackout = blackout
            break
          }
        }
      }
      closestBlackout = format(closestBlackout, "P")

      if (this.props.state.offerDayTrip === false) {
        latestArrivalEnd = sub(latestArrivalEnd, { days: 1 })
      }
      this.props.setGlobalState({
        arrivalStartDate: closestBlackout,
        arrivalEndDate: format(latestArrivalEnd, "P"),
      })
    }
  }

  doesOverlapBlackout(closestBlackout) {
    let arrival = this.props.state.arrival
    const departure = this.props.state.departure

    // if the user has both arrival and departure dates set, there is a possibility it overlaps a blackout
    if (isset(arrival) && isset(departure)) {
      // if arrival is larger then departure, that should fail
      if (
        isAfter(
          parse(arrival, "P", new Date()),
          parse(departure, "P", new Date())
        )
      ) {
        return true
      }
      // loop through each day between arrival and departure and see if any of those dates fall on a blackout
      let invalidDateSpan = false
      while (arrival <= departure) {
        if (
          this.blackoutsKeyValSave &&
          arrival in this.blackoutsKeyValSave &&
          arrival !== closestBlackout
        ) {
          invalidDateSpan = true
          break
        }
        arrival = format(add(parse(arrival, "P", new Date()), { days: 1 }), "P")
        invalidDateSpan = false
      }
      return invalidDateSpan
    } else {
      return false
    }
  }

  isLongerThanMaxNights() {
    if (
      isset(this.props.state.maxNights) &&
      isset(this.props.state.departure)
    ) {
      if (
        differenceInDays(
          parse(this.props.state.departure, "P", new Date()),
          parse(this.props.state.arrival, "P", new Date())
        ) > this.props.state.maxNights
      ) {
        return true
      }
    }
    return false
  }

  blackoutsKeyVal() {
    // this saves a key val version of blackout dates
    const save = {}
    const array = this.props.state.arrivalBlackouts || []
    for (let index = 0; index < array.length; ++index) {
      save[array[index]] = true
    }
    this.blackoutsKeyValSave = save
  }

  handleHideModal() {
    this.setState({ showModal: false })

    // Wait for modal transition to complete before focusing LOA input
    setTimeout(() => {
      if (this.loaInputRef.current) {
        this.loaInputRef.current.focus()
      }
    }, 350) // Headless UI modal transition duration
  }

  boatSelector() {
    if (isset(this.props.state.userBoats)) {
      return (
        <BoatPicker
          state={this.props.state}
          setGlobalState={this.props.setGlobalState}
          debounceRequestsAndSetStateRestrictions={() =>
            this.debounceRequestsAndSetStateRestrictions("boat")
          }
          errors={this.state.boatErrors}
        />
      )
    }
  }

  dockTypeSelector() {
    if (this.props.state.multiDockage) {
      return (
        <div className="form-group" id="spaceTypeSelector">
          <label htmlFor="spaceType">Space Type</label>
          <select
            className="form-control"
            id="spaceType"
            value={this.props.state.dockType}
            onChange={this.changeDockType}
            ref={this.dockSelectorRef}
          >
            <option value="Dock" id="spaceTypeDock">
              Dock
            </option>
            <option value="Mooring" id="spaceTypeMooring">
              Mooring
            </option>
          </select>
        </div>
      )
    }
  }

  changeDockType() {
    this.props.setGlobalState(
      { dockType: this.dockSelectorRef.current?.value },
      () => {
        this.debounceRequestsAndSetStateRestrictions("dock-type")
      }
    )
  }

  datepickerChangeDockType(value) {
    this.props.setGlobalState({ dockType: value }, () => {
      this.debounceRequestsAndSetStateRestrictions("dock-type")
    })
  }

  debounceRequestsAndSetStateRestrictions(dimension) {
    switch (dimension) {
      case "loa":
      case "boat":
      case "dock-type":
        this.updateBlackouts()
    }
    this.validateBoatDimensions()
  }

  updateBlackouts() {
    if (isset(this.props.state.loa)) {
      this.startLoadingBlackouts()
      const postObject = {
        length_overall: this.props.state.loa * 12,
        requested_space_type: this.props.state.dockType,
        boat_id: this.props.state.boatId,
        beam: this.props.state.beam,
      }
      $.post(this.props.blackoutEndpoint, postObject, (data) => {
        // check if any of the data from the server has changed
        if (
          !areSame(data.blackouts, this.props.state.arrivalBlackouts) ||
          !areSame(data.max_nights, this.props.state.maxNights) ||
          !areSame(data.days_in_advance, this.props.state.daysInAdvance)
        ) {
          this.clearDates()
        }
        this.setDates(data)
        this.endLoadingBlackouts()
      }).fail(() => {
        alert(
          "Something went wrong loading the calendar, please contact Dockwa support at mayday@dockwa.com"
        )
      })
    } else {
      this.getBookNowData()
    }
  }

  startLoadingBlackouts() {
    this.setState({ loadingBlackouts: true })
    $(
      '<style id="loading-blackouts">.datepicker-days .table-condensed{visibility: hidden;} .datepicker .prev,.datepicker .next{visibility: hidden !important;} .datepicker-days::before{display: block !important;}</style>'
    ).appendTo("head")
  }

  endLoadingBlackouts() {
    this.setState({ loadingBlackouts: false }, () => {
      this.getBookNowData()
    })
    $("#loading-blackouts").remove()
  }

  setDates(data) {
    let arrivalEnd = this.props.state.marinaEndDate
    let departureEnd = format(
      add(parse(this.props.state.marinaEndDate, "P", new Date()), { days: 1 }),
      "P"
    )
    if (isset(data.days_in_advance)) {
      arrivalEnd = format(
        min([
          add(new Date(), { days: data.days_in_advance }),
          parse(arrivalEnd, "P", new Date()),
        ]),
        "P"
      )
      departureEnd = format(
        min([
          add(new Date(), { days: parseInt(data.days_in_advance) + 1 }),
          parse(departureEnd, "P", new Date()),
        ]),
        "P"
      )
    }
    let departureStartDate = this.props.state.marinaStartDate
    if (this.props.state.offerDayTrip === false) {
      departureStartDate = format(
        add(parse(departureStartDate, "P", new Date()), { days: 1 }),
        "P"
      )
    }
    this.props.setBlackoutDates(data.blackouts)
    this.props.setGlobalState(
      {
        maxNights: data.max_nights,
        daysInAdvance: data.days_in_advance,
        arrivalStartDate: this.props.state.marinaStartDate,
        departureStartDate,
        arrivalEndDate: arrivalEnd,
        departureEndDate: departureEnd,
      },
      () => {
        this.blackoutsKeyVal()
        this.canCheckoutTill()
        this.setCheckinBoundary()
      }
    )
  }

  clearDates() {
    // Sometimes if a user clicks too quickly, these inputs are not present and it crashes the whole component
    if (this.arrivalInputRef.current) {
      this.arrivalInputRef.current.clearDates()
    }
    if (this.departureInputRef.current) {
      this.departureInputRef.current.clearDates()
    }
    this.props.setGlobalState({
      arrival: "",
      departure: "",
    })
  }

  loaSection() {
    if (
      !isset(this.props.state.userBoats) ||
      this.props.state.boatCreated === "now"
    ) {
      return (
        <div
          className={classNames("form-group length-overall", {
            "has-error": this.state.boatErrors.loa,
          })}
        >
          <label htmlFor="lengthOverall">Length overall</label>
          <div className="form-control-with-icon">
            <span className="form-control-icon-right">ft</span>
            <input
              id="lengthOverall"
              type="text"
              className="form-control"
              value={this.props.state.loa}
              onChange={this.handleLOAChange}
              ref={this.loaInputRef}
              data-content="Please round up to the nearest foot and include bowsprit, swim platform, davits, etc."
              data-container="body"
              data-trigger="focus"
              data-toggle="popover"
              data-placement="left"
            />
            {this.state.boatErrors.loa && (
              <span className="control-label">{this.state.boatErrors.loa}</span>
            )}
          </div>
        </div>
      )
    }
  }

  verticalSection() {
    if (
      this.props.state.boatCreated !== "previously" ||
      this.props.state.height == null ||
      this.props.state.draft == null
    ) {
      return (
        <div className="estimate-price-form">
          <div
            className={classNames("form-group", {
              "has-error": this.state.boatErrors.height,
            })}
          >
            <label htmlFor="height">Height</label>
            <div className="form-control-with-icon">
              <span className="form-control-icon-right">ft</span>
              <input
                type="text"
                id="height"
                className="form-control"
                value={this.props.state.height}
                onChange={this.handleHeightChange}
                ref={this.heightInputRef}
              />
              {this.state.boatErrors.height && (
                <span className="control-label">
                  {this.state.boatErrors.height}
                </span>
              )}
            </div>
          </div>
          <div
            className={classNames("form-group", {
              "has-error": this.state.boatErrors.depth,
            })}
          >
            <label htmlFor="draft">Draft</label>
            <div className="form-control-with-icon">
              <span className="form-control-icon-right">ft</span>
              <input
                type="text"
                id="draft"
                className="form-control"
                value={this.props.state.draft}
                onChange={this.handleDrawChange}
                ref={this.draftInputRef}
              />
              {this.state.boatErrors.depth && (
                <span className="control-label">
                  {this.state.boatErrors.depth}
                </span>
              )}
            </div>
          </div>
        </div>
      )
    }
  }

  oppositeSpaceType() {
    if (this.props.state.multiDockage) {
      return this.props.state.dockType === "Dock" ? "Mooring" : "Dock"
    }
    return false
  }

  render() {
    return (
      <div id="priceEstimatorContainer" className="estimate-price-component">
        <BSModal
          isOpen={this.state.showModal}
          handleHideModal={this.handleHideModal}
          title="Please Enter Length Overall"
          body="You must enter a length overall before you can select your arrival and departure dates."
        />
        {this.boatSelector()}
        {this.dockTypeSelector()}
        <div className="estimate-price-form">
          {this.loaSection()}
          <div className="form-group">
            <label htmlFor="arrival">Arrival</label>
            <div
              className="form-control-with-icon"
              style={{ position: "relative" }}
            >
              {!isset(this.props.state.loa) && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1,
                    cursor: "not-allowed",
                  }}
                  onClick={() => this.setState({ showModal: true })}
                />
              )}
              <i className="icon icon-calendar form-control-icon-left" />
              <DatePicker
                ref={this.arrivalInputRef}
                prependWaitlist={this.props.waitlistFeature}
                prependDockOrMooring={this.oppositeSpaceType()}
                changeDockType={this.datepickerChangeDockType}
                uniqueKey="arrival"
                id="arrival"
                routeTo={this.props.routeTo}
                setParentState={this.arrivalState}
                value={this.props.state.arrival}
                startDate={this.props.state.arrivalStartDate}
                endDate={this.props.state.arrivalEndDate}
                datesDisabled={this.props.state.arrivalBlackouts}
                loadingBlackouts={this.state.loadingBlackouts}
                marina={this.props.marina}
                experienceName={"reservation_flow"}
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="departure">Departure</label>
            <div
              className="form-control-with-icon"
              style={{ position: "relative" }}
            >
              {!isset(this.props.state.loa) && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1,
                    cursor: "not-allowed",
                  }}
                  onClick={() => this.setState({ showModal: true })}
                />
              )}
              <i className="icon icon-calendar form-control-icon-left" />
              <DatePicker
                ref={this.departureInputRef}
                prependWaitlist={this.props.waitlistFeature}
                prependDockOrMooring={this.oppositeSpaceType()}
                changeDockType={this.datepickerChangeDockType}
                uniqueKey="departure"
                id="departure"
                routeTo={this.props.routeTo}
                setParentState={this.departureState}
                value={this.props.state.departure}
                startDate={this.props.state.departureStartDate}
                endDate={this.props.state.departureEndDate}
                datesDisabled={this.props.state.departureBlackouts}
                loadingBlackouts={this.state.loadingBlackouts}
                marina={this.props.marina}
                experienceName={"reservation_flow"}
              />
            </div>
          </div>
        </div>
        {this.verticalSection()}
        {this.props.useDockwaPlusPricing ? null : (
          <PromoCode
            setGlobalState={this.props.setGlobalState}
            reloadPricing={this.getBookNowData}
            promoCode={this.props.state.promoCode}
            referralCode={this.props.state.referralCode}
            email={this.props.state.email}
            userId={this.props.state.userId}
            marinaSlug={this.props.state.marinaSlug}
            marina={this.props.marina}
            experienceName={"reservation_flow"}
          />
        )}
        {this.bookNow()}
        {!!this.props.last4WeekAvgPendingResTime && (
          <div className="mt-4 text-center">
            {`${this.props.state.marinaName} typically responds to reservation requests in ${this.props.last4WeekAvgPendingResTime}.`}
          </div>
        )}
      </div>
    )
  }
}

PriceEstimator.propTypes = {
  setGlobalState: PropTypes.func.isRequired,
  setHeader: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  priceEndpoint: PropTypes.string.isRequired,
  priceV2Endpoint: PropTypes.string,
  blackoutEndpoint: PropTypes.string.isRequired,
  boatDimensionValidationEndpoint: PropTypes.string,
  setBlackoutDates: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  last4WeekAvgPendingResTime: PropTypes.string,
  waitlistFeature: PropTypes.bool,
  whiteLabel: PropTypes.bool,
  marina: PropTypes.object.isRequired,
  experienceName: PropTypes.string,
  useDockwaPlusPricing: PropTypes.bool,
  openDockwaPlusModal: PropTypes.func,
  embedForm: PropTypes.bool,
}

export default PriceEstimator
